import { IAbstractRecord } from '@models';
import { IProductionDetailsSummary } from '../../../..';
import PrecisionService from '@services/PrecisionService';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

export const getMarineInputs = (
  lovs: Record<string, IAbstractRecord>,
  values: IProductionDetailsSummary
): IDynamicFormWidgetSection[] => {
  return [
    {
      inputs: {
        Matter: {
          name: 'Matter',
          title: 'Matter',
          type: FormFieldType.select,
          placeholder: 'Matter',
          value: values?.Marine?.matterCode || '',
          required: true,
          hidden: false,
          selectOptions: lovs?.matters,
        },
        Description: {
          name: 'Description',
          title: 'Description',
          type: FormFieldType.text,
          placeholder: 'Description',
          value: values?.Marine?.description || '',
          required: true,
          hidden: false,
        },
        VesselName: {
          name: 'VesselName',
          title: 'Vessel Name',
          type: FormFieldType.text,
          placeholder: 'Vessel Name',
          value: values?.Marine?.vesselName || '',
          required: true,
          hidden: false,
        },
        VesselAge: {
          name: 'VesselAge',
          title: 'Vessel Age',
          type: FormFieldType.number,
          placeholder: 'Vessel Age',
          value: values?.Marine?.vesselAge || '',
          required: false,
          hidden: false,
        },
        From: {
          name: 'From',
          title: 'From',
          type: FormFieldType.text,
          placeholder: 'From',
          value: values?.Marine?.from || '',
          required: true,
          hidden: false,
        },
        To: {
          name: 'To',
          title: 'To',
          type: FormFieldType.text,
          placeholder: 'To',
          value: values?.Marine?.to || '',
          required: true,
          hidden: false,
        },
        Via: {
          name: 'Via',
          title: 'Via',
          type: FormFieldType.text,
          placeholder: 'Via',
          value: values?.Marine?.via || '',
          required: true,
          hidden: false,
        },
        Survey: {
          name: 'Survey',
          title: 'Survey',
          type: FormFieldType.text,
          placeholder: 'Survey',
          value: values?.Marine?.survey || '',
          required: true,
          hidden: false,
        },
        CargoContract: {
          name: 'CargoContract',
          title: 'Cargo Contract',
          type: FormFieldType.text,
          placeholder: 'Cargo Contract',
          value: values?.Marine?.cargoContract || '',
          required: true,
          hidden: false,
        },
        SumPerShipmentCurrency: {
          name: 'SumPerShipmentCurrency',
          title: 'Sum Per Shipment Currency',
          type: FormFieldType.select,
          placeholder: 'Sum Per Shipment Currency',
          value: values?.Marine?.sumPerShipmentCurrencyCode || '',
          required: true,
          hidden: false,
          injectGlobalLov: {
            type: 'currency',
            value: 'Code',
            display: 'Title',
          },
        },
        SumPerShipment: {
          name: 'SumPerShipment',
          title: 'Sum Per Shipment',
          type: FormFieldType.currency,
          placeholder: 'Sum Per Shipment',
          value: values?.Marine?.sumPerShipment || '',
          required: false,
          hidden: false,
          currencySymbol: values.Marine.sumPerShipmentCurrency,
        },
        SumPerShipmentPolicyCurrency: {
          name: 'SumPerShipmentPolicyCurrency',
          title: 'Sum Per Shipment In Policy Currency',
          type: FormFieldType.currency,
          placeholder: 'Sum Per Shipment In Policy Currency',
          value: values?.Marine?.sumPerShipmentPolicyCurrency || '',
          required: false,
          hidden: false,
          currencySymbol: values?.PolicyCurrency?.Symbol,
          disabled: true,
        },
        LCNumber: {
          name: 'LCNumber',
          title: 'LC Number',
          type: FormFieldType.text,
          placeholder: 'LC Number',
          value: values?.Marine?.lcNumber || '',
          required: false,
          hidden: false,
        },
        LCIssueDate: {
          name: 'LCIssueDate',
          title: 'LC Issue Date',
          type: FormFieldType.date,
          placeholder: 'LC Issue Date',
          value: values?.Marine?.lcIssueDate || '',
          required: false,
          hidden: false,
        },
        Bank: {
          name: 'Bank',
          title: 'Bank',
          type: FormFieldType.text,
          placeholder: 'Bank',
          value: values?.Marine?.bank || '',
          required: false,
          hidden: false,
        },
        ClaimsPayableBy: {
          name: 'ClaimsPayableBy',
          title: 'Claims Payable by',
          type: FormFieldType.text,
          placeholder: 'Claims Payable by',
          value: values?.Marine?.claimsPayableBy || '',
          required: true,
          hidden: false,
        },
        Loading: {
          name: 'Loading',
          title: 'Loading',
          type: FormFieldType.percentage,
          placeholder: 'Loading',
          value: PrecisionService.multiplyBy100(values?.Marine?.loading) || '',
          required: true,
          hidden: false,
          disabled: true,
        },
        Remarks: {
          name: 'Remarks',
          title: 'Remarks',
          type: FormFieldType.textArea,
          placeholder: 'Remarks',
          value: values?.Marine?.remarks || '',
          required: false,
          hidden: false,
        },
      },
    },
  ];
};
